(() => {
  const init = (root) => {
    if (!root || !root.matches('[data-tan-property-journey]') || root.dataset.propertyJourneyReady) return;
    root.dataset.propertyJourneyReady = 'true';

    const preview = root.querySelector('[data-property-wall-preview]');
    const choices = Array.from(root.querySelectorAll('[data-property-zone-choice]'));
    const ambient = root.querySelector('[data-property-ambient]');
    const ambientValue = root.querySelector('[data-property-ambient-value]');
    const resultHeading = root.querySelector('[data-property-zone-heading]');
    const resultCopy = root.querySelector('[data-property-zone-copy]');
    const resultList = root.querySelector('[data-property-zone-list]');

    const updateChoice = (choice) => {
      if (!choice || !preview) return;
      choices.forEach((item) => {
        const active = item === choice;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });

      preview.dataset.mode = choice.dataset.modeKey || 'arrival';
      if (resultHeading) resultHeading.textContent = choice.dataset.zoneTitle || '';
      if (resultCopy) resultCopy.textContent = choice.dataset.zoneNote || '';

      const payload = root.querySelector(`[data-property-zone-payload="${CSS.escape(choice.dataset.zoneId || '')}"]`);
      const content = payload?.content.querySelector('[data-property-zone-checklist]');
      if (resultList && content) resultList.innerHTML = content.innerHTML;

      ['viewer', 'constraint', 'evidence'].forEach((metric) => {
        const label = root.querySelector(`[data-property-metric-label="${metric}"]`);
        const value = root.querySelector(`[data-property-metric-value="${metric}"]`);
        if (label) label.textContent = choice.dataset[`${metric}Label`] || '';
        if (value) value.textContent = choice.dataset[`${metric}Value`] || '';
      });
    };

    const updateAmbient = () => {
      if (!ambient || !preview) return;
      const strength = Number(ambient.value) / 100;
      preview.style.setProperty('--property-daylight', String(0.08 + strength * 0.52));
      preview.style.setProperty('--property-glow', String(0.72 + (1 - strength) * 0.28));
      preview.style.setProperty('--property-room-light', String(0.18 + strength * 0.62));
      if (ambientValue) ambientValue.textContent = `${ambient.value}%`;
    };

    choices.forEach((choice) => choice.addEventListener('click', () => updateChoice(choice)));
    ambient?.addEventListener('input', updateAmbient);
    updateAmbient();
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-tan-property-journey]')) init(scope);
    scope.querySelectorAll?.('[data-tan-property-journey]').forEach(init);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
